import functions from './functions.js';
import Slider from "./Slider";
import { Calendar } from  './calendar.js';

$(() => {
    details.init();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '2,0,0', 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    cart: [],
    init() {

        let cartData = functions.getCookie('cart_data');
        if(cartData) {
            cartData = JSON.parse(cartData);
            $('.cart-items-count').text(cartData.length);
            cartData.forEach(item => {
                details.cart.push(JSON.stringify(item));
            });
        }

        if(! $('.page-type-details')[0]) {
            return;
        }

        $('.btn-print').on('click', e => {
            const params = $('.btn-print').attr('data-params');

            if(params) {
                const url = location.protocol + '//' + location.hostname + '/services/itinerary' + params;
                window.open(url, '_blank').focus();
            }
        });

        let detailsSlider = new Slider('#details-gallery-slider', {
            rubberband: false,
            loop: true,
            arrows: true,
            slidesPerView: 1,
            duration: 1000,
            //autoplay: 3000,
            autoplay: 0,
            pauseOnHover: true,
            pager: true,
            breakpoints: {
                '(max-width: 1000px)': {
                    slidesPerView: 1
                },
            },
        });

        let itinerarySlider = [];
        $('[id^=details-itinerary-slider]').each((i, elem) => {
            itinerarySlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                controls: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                duration: 1000,
                pager: true,
                autoplay: 0,
                pauseOnHover: true,
            });
        });

        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 8;

            let slidesPerView = length < perView ? length + 1 : perView;

            if(length < perView) {
                $('.booking-calendar-wrapper').addClass('col-lg-' + slidesPerView);
                $('.booking-calendar-wrapper').addClass('mx-auto');
            }

            window.mobileAndTabletCheck = function () {
                let check = false;
                (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                return check;
            };
    
            details.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                spacing: 8,
                arrows: window.mobileAndTabletCheck() || length > perView,
                slidesPerView: perView,
                breakpoints: {
                    '(min-width: 577px) and (max-width: 1024px)': {
                        slidesPerView: 6.2,
                        controls: true,
                        arrows: length > 6,
                        //centered: true,
                    },
                    '(max-width: 576px)': {
                        slidesPerView: 2.1,
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                    },
                },
            });
        }

        details.getParams();

        details.$form = $('.availability-form');
        details.form = details.$form[0];

        details.params.objectId = details.$form.attr('data-objectid');
        details.params.idList = details.$form.attr('data-idlist');
        details.params.objectGroupId = details.$form.attr('data-objectgroupid');
        details.params.unitId = details.$form.attr('data-unitid');

        functions.setFormData(details.form, functions.getUrlData(true));

        details.splitCalendarDates($('[name=dates]').val());

        $('[id^=rate]').on('shown.bs.collapse', e => {
            const $target = $(e.currentTarget);
            const id = $(e.currentTarget).attr('id');
            const $calendar = $target.find('[data-calendarconfig][data-rateid=' + id + ']');

            if($calendar[0] && ! $('[name="arrangedDates"][data-rateid=' + id + ']').hasClass('flatpickr-input')) {
               details.calendarInit($calendar.attr('data-unitid'), id);
            }

        });

        let availabilitySlider = [];
        $('[id^=availability]').on('shown.bs.tab', e => {
            $('#availability-slider-' + $(e.target).attr('data-unitid')).each((i, elem) => {
                availabilitySlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slidesPerView: 4,
                    spacing: 8,
                    breakpoints: {
                        '(max-width: 1000px)': {
                            slidesPerView: 1,
                            spacing: 0,
                        },
                    },
                });
            });
        });

        details.calcErrorMessages = $('#availability').attr('data-calcErrorMessages') ? JSON.parse($('#availability').attr('data-calcErrorMessages')) : null;

        if(details.params.objectGroupId == 6) {

            details.params.dateFrom = ! details.params.dateFrom ? $('[data-datefrom]').attr('data-datefrom') : details.params.dateFrom;
            $('[data-datefrom=' + details.params.dateFrom + ']').addClass('active');
            details.params.dateTo = $('[data-datefrom=' + details.params.dateFrom + ']').attr('data-dateto');

            details.params.guests = $('[name=guests]').val(); 

            functions.setUrlData({'dateFrom': details.params.dateFrom, 'guests': details.params.guests }, true);

            $('.departure[data-dateFrom=' + details.params.dateFrom +']').each((index, elem) => {
                details.printDeparturePriceFrom($(elem));
            });
        }

        if(details.params.guests) {
            $('form.unit-guests-form').each((index, item) => {
                functions.setFormData(item, { 'guests': details.params.guests });
            });
        }

        details.getCalculation();

        details.$form.on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            let data = functions.getFormData($target);
            //data.guests = details.params.guests;
            functions.setUrlData(data, true);
        });

        $('form.unit-guests-form').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            const unitId = $target.attr('data-unitid');
            details.params.guests = $target.val();
            details.getCalculation(unitId);
        });

        $('form.arrangement-form').on('change', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const unitId = $target.attr('data-unitid');
            const rateId = $target.attr('data-rateid');

            details.params = $.extend({}, details.params, functions.getFormData($target));
            details.splitCalendarDates(details.params.arrangedDates);

            details.getCalculation(unitId, rateId);
        });

        $('.departure').on('click', e => {
            $('.departure').removeClass('active');
            let $target = $(e.target);
            $target = $target.hasClass('departure') ? $target : $target.parents('.departure');
            $target.addClass('active');
            details.params.dateFrom = $target.attr('data-datefrom');
            $('[data-datefrom=' + details.params.dateFrom + ']').addClass('active');
            details.params.dateTo = $target.attr('data-dateto');

            details.printDeparturePriceFrom($target);

            functions.setUrlData({'dateFrom': details.params.dateFrom, 'guests': details.params.guests }, true);
        });

        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });

        $('button.add-to-cart').on('click', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const unitId = $target.attr('data-unitid');
            const guests = $('.unit-guests-form[data-unitId=' + unitId + ']').find('[name=guests]').val();
            if( ! $target.attr('data-arrangementid')) {
                details.splitCalendarDates(details.params.dates);
            }

            if(unitId && details.params.dateFrom && details.params.dateTo && guests) {
                let cartItem = {
                    'unitId': unitId,
                    'dateFrom': details.params.dateFrom,
                    'dateTo': details.params.dateTo,
                    'guests': details.params.guests,
                };
                details.cart.push(JSON.stringify(cartItem));
            }

            functions.setCookie('cart_data', '[' + details.cart + ']');

            $('.cart-items-count').text(JSON.parse(functions.getCookie('cart_data')).length);

            /*$('.btn-cart').attr('href',
                $('.btn-cart').attr('href').split('?')[0] + 
                    '?cart=' + functions.getCookie('cart_data'));*/

            $target.attr('disabled', true);
            $target.css('transition', 'all .2s ease-in');
            $target.addClass('bg-warning');
            $target.addClass('border-warning');
            $target.find('.add').addClass('d-none');
            $target.find('.added').removeClass('d-none');

            setTimeout(() => {
                $target.find('.add').removeClass('d-none');
                $target.find('.added').addClass('d-none');
                $target.removeClass('bg-warning');
                $target.removeClass('border-warning');
                $target.attr('disabled', false);
            }, 2000);
        });

        $('.unit-modal').on('click', e => {
            const $target = $(e.currentTarget);
            $('[id=' + $target.attr('data-tab') +']').tab('show');
        });

        $('.collapse').on('show.bs.collapse', e => {
            const $target = $(e.currentTarget);
            const $button = $('.btn-select[data-target="#' + $target.attr('id') + '"]');
            if( ! $button.hasClass('navbar-toggler')) {
                $button.addClass('btn-danger');
                const $icon = $button.find('.las');
                $icon.css('transition', 'all .3s ease-in');
                $icon.css('transform', 'rotate(-180deg)');
            }
        });
        $('.collapse').on('hide.bs.collapse', e => {
            const $target = $(e.currentTarget);
            const $button = $('.btn-select[data-target="#' + $target.attr('id') + '"]');
            $button.removeClass('btn-danger');
            const $icon = $button.find('.las');
            $icon.css('transition', 'all .3s ease-in');
            $icon.css('transform', 'rotate(0)');
        });

        $('[id^=enquiryModal]').on('shown.bs.modal', e => {
            if(details.params.dateFrom && details.params.dateTo) {
                $(e.currentTarget).find($('.datepicker-range'))[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            }
        });

        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            $.each($(e.currentTarget).serializeArray(), function (i, field) {
                params[field.name] = field.value;
            });

            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            grecaptcha.ready(function () {
                grecaptcha.execute('6LeU1cUeAAAAAIFFN2oVRqyNc5O2MPeE4Del3Ofa', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        response = JSON.parse(response);
                        
                        $('[id^=enquiryModal]').modal('hide');
                        $('#enquiry-modal').modal('show');
                        $(".response-output-2").html(response.data);

                        $('.contact-btn').removeClass('d-none');
                        $('.contact-spinner').removeClass('d-flex');
                        $('.contact-spinner').addClass('d-none');

                        setTimeout(() => { $('#enquiry-modal').modal('hide') }, 6000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });

    },
    printDeparturePriceFrom($target) {
        if(details.params.guests == '0,0,0') {
            let price = $target.attr('data-price');
            let priceEUR = $target.attr('data-priceeur');
            let priceWithDiscountEUR = $target.attr('data-pricewithdiscounteur');
            let priceWithDiscount = $target.attr('data-pricewithdiscount');
            let discountTitle = $target.attr('data-discountTitle');

            priceWithDiscountEUR = priceWithDiscountEUR == '0,00 kn' ? null : priceWithDiscountEUR;

            $('.price-from').find('.price').text( priceWithDiscount ? priceWithDiscount : price );
            $('.price-from').find('.priceEUR').text(priceWithDiscountEUR ? priceWithDiscountEUR : priceEUR);
            
            $('.price-from').find('.priceOld').text( priceWithDiscount ? price : '' );
            $('.price-from').find('.priceOldEUR').text( priceWithDiscountEUR ? priceEUR : '' );

            if(priceWithDiscount) {
                $('.discount-title').text(discountTitle);
                $('.discount-title').removeClass('d-none');
            } else {
                $('.discount-title').text('');
                $('.discount-title').addClass('d-none');
            }
        }
    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);

            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.attr('disabled', 'disabled');
                    }
                    $(".reviews").append(response.html);
                }
            });
        });
    },
    calendarInit(unitId, rateId = null) {
        let config = JSON.parse($('[data-calendarconfig][data-rateid=' + rateId + ']').attr('data-calendarconfig'));
        let mode = $('[data-calendarconfig][data-mode]').attr('data-mode');

        let minDate = new Date($('[data-calendarconfig][data-rateid=' + rateId + ']').attr('data-mindate'));
        let maxDate = new Date($('[data-calendarconfig][data-rateid=' + rateId + ']').attr('data-maxdate'));

        let defaultDate = $('[data-calendarconfig][data-rateid=' + rateId + '][data-defaultdate]').attr('data-defaultdate');
        if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }

        /*calendar.calendar.init(
            $('.datepicker-range-book-' + unitId),
            {
                availabilityMask : config.availabilityMask,
                periods : config.periods,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar-' + unitId + ' mx-auto'
            },
            details.getCalculation
        );*/

        new Calendar(
            $('.datepicker-book-small[data-rateid="' + rateId + '"]'),
            {
                availabilityMask : config.availabilityMask,
                periods : config.periods,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate,
                maxDate: maxDate,
                mode: mode,
                showMonths: 1,
                inline: false,
                wrap: true,
                containerClass : 'details-booking-calendar-small'
            },
            details.getCalculation
        );
    },
    calendarClear() {
        $('.datepicker-range-book[name="dates"]').flatpickr().clear();
        details.params.dates = null;
        $('.unit-dates').text('--');
        $('.unit-price-total').text('--');
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data, rateId = null) {
        if(rateId) {
            return (data.booking.status == 'Request' || data.booking.status == 'Reservation') && data.isAvailable && data.calc.status == 'Active';
        }
        // booking status Reservations ili Request
        return (data.booking.status == 'Request' || data.booking.status == 'Reservation') && data.calc.status == 'Active';
        //return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    getCalculation(unitId = null, rateId = null) {

        const dateFrom = details.params.dateFrom;
        details.params.dateTo = details.params.dateTo ? details.params.dateTo : dateFrom;
        const dateTo = details.params.dateTo;

        //console.log(details.params);
        
        if(
            (details.params.objectId || unitId || details.params.idList)
            && details.params.guests 
            && dateFrom 
            && dateTo 
            && details.params.objectGroupId
        ) {

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : (details.params.idList ? '?idList=' + details.params.idList : '?objectId=' + details.params.objectId))
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
            )
            .done(response => {

                //console.log(response);

                if(response.status) {
                    const data = response.data || [];

                    Object.entries(data).forEach(unit => {
                        const unitId = unit[0];
                        const unitData = unit[1];

                        const $unit = rateId ? $('.arrangement-form[data-rateid=' + rateId + ']') : $('.unit[data-unitid=' + unitId + ']');
                        const $btnAdd = rateId ? $unit.find('.add-to-cart[data-rateid="' + rateId + '"]') : $unit.find('.add-to-cart');
                        
                        if(details.isBookable(unitData, rateId)) {
                            const unitCalc = unitData.calc;

                            const calcItems = unitCalc.items;
                            let priceOld = 0.00;
                            let priceWithDiscountEUR = 0.00;
                            let discountTitle = null;
                            let percent = null;

                            calcItems.forEach(item => {
                                // popust za djecu ne ulazi u prikaz discount cijene (129)
                                // popust za osobu na pomoćnom ležaju ne ulazi u prikaz discount cijene (14)
                                if((item.itemType != 'discount' || item.itemDefinitionId == 129 || item.itemDefinitionId == 14) && !item.optional && !item.onSpot) {
                                    priceOld += item.itemTotal;
                                    priceWithDiscountEUR += item.itemTotalEUR;
                                }

                                if(item.itemType == 'discount') {
                                    //percent = (Math.abs(item.itemTotal) / priceOld).toFixed(2) * 100;
                                    //discountTitle = item.itemTitle;
                                    if(item.data && item.data.text) {
                                        //discountTitle = item.data.text;
                                    }
                                }
                            });

                            const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 2, ',', '.');

                            $btnAdd.attr('disabled', false);
                            $btnAdd.removeClass('d-none');

                            $('.departure-date-from').text(functions.formatDate(dateFrom));
                            $('.departure-date-to').text(functions.formatDate(dateTo));

                            $unit.find('.price-from').addClass('d-none');

                            //$unit.find('form.unit-guests-form').removeClass('d-none');
                            $unit.find('.unit-error-container').addClass('d-none');
                            $unit.find('.unit-price').removeClass('d-none');

                            //$unit.find('.unit-price-discount-title').text(discountTitle);
                            //percent && $unit.find('.unit-price-discount-percent').text(percent + '%');
                            //$unit.find('.unit-price-discount-title').removeClass('d-none');

                            $unit.find('.unit-price-discount-percent').addClass('d-none');
                            $unit.find('.unit-price-discount-title').addClass('d-none');
                            $unit.find('.unit-price-discount-valid-until').addClass('d-none');
                            //$unit.find('.unit-price').addClass('d-none');

                            $unit.find('.unit-price-label').addClass('d-none');
                            $unit.find('.unit-payment-label').addClass('d-none');
                            $unit.find('.unit-price-total-label').removeClass('d-none');
                            if(priceOld > unitCalc.total) {
                                $unit.find('.unit-price-old').text(unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 2, ',', '.'));
                                $unit.find('.unit-price-old').removeClass('d-none');
                            } else {
                                $unit.find('.unit-price-old').addClass('d-none');
                            }
                            $unit.find('.unit-price-total').text(total);

                            if(unitCalc.currencySymbol == '€') {
                                if(priceWithDiscountEUR > unitCalc.totalEUR) {
                                    $unit.find('.unit-price-old-eur').text(functions.formatMoney(priceWithDiscountEUR, 2, ',', '.'));
                                    $unit.find('.unit-price-old-eur-container').removeClass('d-none');
                                    $unit.find('.unit-price-old-eur').removeClass('d-none');
                                    $unit.find('.unit-currency-old-eur').removeClass('d-none');
                                } else {
                                    $unit.find('.unit-price-old-eur-container').addClass('d-none');
                                    $unit.find('.unit-price-old-eur').addClass('d-none');
                                    $unit.find('.unit-currency-old-eur').addClass('d-none');
                                }
                                $unit.find('.unit-price-total-eur').text(functions.formatMoney(unitCalc.totalEUR, 2, ',', '.'));
                            }

                            /*$('.unit-price-total').text(total);
                            $('.unit-price-total').removeClass('d-none');
                            $('.unit-total-price').removeClass('d-none');
                            $('.unit-price-from').addClass('d-none');
                            $('.unit-price-night').addClass('d-none');
                            $('.unit-price-container').removeClass('d-none');
                            $('.unit-error-container').addClass('d-none');

                            $('.unit-dates').text(functions.formatDate(details.params.dateFrom, 'dd.mm.') + ' - ' + (details.params.dateTo ? functions.formatDate(details.params.dateTo, 'dd.mm.yyyy.') : ''));*/

                            /*if($btnBooking.attr('href')) {
                                $btnBooking.attr('href',
                                    $btnBooking.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '&dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests
                                );
                            }*/

                            if(details.params.objectGroupId == 6) {
                                const minOccupancy = +$('.unit-guests-form[data-unitid="' + unitId + '"]').attr('data-minoccupancy');

                                if(minOccupancy) {
                                    const guests = unitData.calc.guests.split(',');
                                    const persons = +guests[0] + +guests[1];
                                    const isBookable = persons % minOccupancy == 0 || persons >= minOccupancy;
                                    let message = (functions.getLang() == 'hr' ? 'Minimalan broj osoba: ' : 'Minimum number of persons: ') + minOccupancy;
                                    $unit.find('.unit-error-container').toggleClass('d-none', isBookable).html(message);
                                    $btnAdd.toggleClass('d-none', ! isBookable);
                                }
                            }

                        } else {
                            $btnAdd.attr('disabled', true);
                            $btnAdd.addClass('d-none');
                            //$unit.find('form.unit-guests-form').addClass('d-none');

                            if(details.params.guests != '0,0,0') {
                                $unit.find('.price-from').addClass('d-none');
                                $unit.find('.unit-error-container:not(.arrangement-sold)').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                            } else {
                                $unit.find('.price-from').removeClass('d-none');
                            }

                            if(rateId) {
                                $unit.find('.unit-error-container').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                            }

                            $unit.find('.unit-price').addClass('d-none');
                            $unit.find('.unit-price-discount-title').addClass('d-none');
                            $unit.find('.unit-price-label').removeClass('d-none');
                            $unit.find('.unit-payment-label').removeClass('d-none');
                            $unit.find('.unit-price-total-label').addClass('d-none');
                            //$('.unit-price-container[data-unitid=' + unitId + ']').addClass('d-none');
                            //$('.unit-price-total[data-unitid=' + unitId + ']').addClass('d-none');
                            //$('.unit-total-price[data-unitid=' + unitId + ']').addClass('d-none');
                            //$('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                            //$('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');

                            $('.departure-date-from').text(functions.formatDate(dateFrom));
                            $('.departure-date-to').text(functions.formatDate(dateTo));
                        }

                    });
                }

            }).fail(function (error) {
                console.log(error);
            });
        }

        else {
            $('.btn-booking').addClass('disabled');
        }
    }
}